/** @format */

import styled from '@emotion/styled';

export const StyledAutocompleteItems = styled.div`
  max-height: 150px;
`;
